import _extends from '@babel/runtime/helpers/esm/extends';
import * as React from 'react';

var BackArrow = /*#__PURE__*/React.forwardRef(function (props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 10 16",
    width: "1em",
    height: "1em",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M8.505 1a.498.498 0 01.35.137.442.442 0 01.145.335.442.442 0 01-.146.335L2.21 8.047l6.558 6.16c.097.09.146.2.146.328a.435.435 0 01-.146.328.502.502 0 01-.357.137.502.502 0 01-.357-.137L1.146 8.376A.435.435 0 011 8.048c0-.128.049-.237.146-.329l7.009-6.582A.535.535 0 018.505 1z",
    fill: "#225447",
    stroke: "#225447"
  }));
});
BackArrow.displayName = 'BackArrow';

export { BackArrow, BackArrow as default };
